import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import users from "./users.json";
import charges from "./charges.json";
import settings from "./settings.json";
import tcoCalculator from "./tco-calculator.json";

const fleetAtHomeManagement = {
  ...getI18nJsonProp(base, "fleetAtHomeManagement"),
  ...getI18nJsonProp(charges, "fleetAtHomeManagement"),
  ...getI18nJsonProp(users, "fleetAtHomeManagement"),
  ...getI18nJsonProp(settings, "fleetAtHomeManagement"),
  ...getI18nJsonProp(tcoCalculator, "fleetAtHomeManagement"),
};

export default fleetAtHomeManagement;
